module.exports = __webpack_public_path__ + "static/media/img_familia.9aa28e73.jpg";